/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S7_Li3_TermInputs */

const tr_iade_iptal_s7_li3_term = /** @type {(inputs: Iade_Iptal_S7_Li3_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedel değişikliği:`)
};

const en_iade_iptal_s7_li3_term = /** @type {(inputs: Iade_Iptal_S7_Li3_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change of price:`)
};

const de_iade_iptal_s7_li3_term = /** @type {(inputs: Iade_Iptal_S7_Li3_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preisänderung:`)
};

const ru_iade_iptal_s7_li3_term = /** @type {(inputs: Iade_Iptal_S7_Li3_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение стоимости:`)
};

/**
* | output |
* | --- |
* | "Change of price:" |
*
* @param {Iade_Iptal_S7_Li3_TermInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s7_li3_term = /** @type {((inputs?: Iade_Iptal_S7_Li3_TermInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S7_Li3_TermInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s7_li3_term(inputs)
	if (locale === "de") return de_iade_iptal_s7_li3_term(inputs)
	if (locale === "ru") return ru_iade_iptal_s7_li3_term(inputs)
	return tr_iade_iptal_s7_li3_term(inputs)
});